export default settings = window.settings || {}